import { CURRENT_UNLIMITED_MODEL_KEYS } from './plan-benefits.js';

const newModelMenuItem = (item) => ({
  ...item,
  badges: [
    { badge: 'New', badgeKey: 'new', badgeTone: 'new' },
    ...(CURRENT_UNLIMITED_MODEL_KEYS.has(item.key)
      ? [{ badge: 'Unlimited', badgeKey: 'unlimited', badgeTone: 'unlimited' }]
      : []),
  ],
});

const BOTGO_IMAGE_25_FLASH_MENU_ITEM = newModelMenuItem({
  key: 'botgo-image-2.5-flash',
  label: 'BotGo Image 2.5 Flash',
  labelKey: 'botgoImage25Flash',
  href: '/botgo-image/botgo-image-2-5-flash',
  logo: '/brand/botgo-symbol-white.svg?v=orbit-centered-03',
  description: 'Fast image creation, guided edits, and up to three references.',
});

const BOTGO_VIDEO_25_FLASH_MENU_ITEM = newModelMenuItem({
  key: 'botgo-video-2.5-flash',
  label: 'BotGo Video 2.5 Flash',
  labelKey: 'botgoVideo25Flash',
  href: '/botgo-video/botgo-video-2-5-flash',
  logo: '/brand/botgo-symbol-white.svg?v=orbit-centered-03',
  description: 'Fast video with text, frames, image references, and native audio.',
});

const GPT_IMAGE_25_MENU_ITEM = newModelMenuItem({
  key: 'gpt-image-2.5-special',
  label: 'GPT Image 2.5',
  labelKey: 'gptImage25',
  href: '/gpt-image/gpt-image-2-5',
  logo: '/Logo/openai.svg',
  description: 'Detailed image creation, reference consistency, and precise edits.',
});

const MINIMAX_H3_MAX_MENU_ITEM = newModelMenuItem({
  key: 'minimax-h3-max',
  label: 'MiniMax H3 Max',
  labelKey: 'minimaxH3Max',
  href: '/minimax/minimax-h3-max',
  logo: '/Logo/minimax.svg',
  description: 'Fast video drafts from prompts, images, and first/last frames.',
});

const GEMINI_OMNI_11_MENU_ITEM = newModelMenuItem({
  key: 'gemini-omni-1.1-flash',
  label: 'Gemini Omni 1.1 Flash',
  labelKey: 'geminiOmni11',
  href: '/gemini-omni/omni-1-1-flash',
  logo: '/Logo/google.svg',
  description: '360p drafts, up to 4K output, multimodal references, and editing.',
});

const SORA_2_MENU_ITEM = {
  key: 'sora-2',
  label: 'Sora 2',
  labelKey: 'sora2',
  href: '/sora/sora-2',
  logo: '/Logo/openai.svg',
  description: 'Natural motion with strong physics and scene continuity.',
};

const SORA_2_PRO_MENU_ITEM = {
  key: 'sora-2-pro',
  label: 'Sora 2 Pro',
  labelKey: 'sora2Pro',
  href: '/sora/sora-2-pro',
  logo: '/Logo/openai.svg',
  description: 'Polished, longer-form video with precise prompt control.',
};

const SEEDANCE_20_MENU_ITEM = {
  key: 'seedance-2.0',
  label: 'Seedance 2.0',
  labelKey: 'seedance20',
  href: '/seedance/2.0',
  logo: '/Logo/bytedance.svg',
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Multimodal video with references, frames, audio, and 4K.',
};

const SEEDANCE_25_MENU_ITEM = {
  key: 'seedance-2.5',
  label: 'Seedance 2.5',
  labelKey: 'seedance25',
  href: '/seedance/seedance-2-5',
  logo: '/Logo/bytedance.svg',
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Longer cinematic scenes with rich reference control.',
};

const SEEDANCE_15_PRO_MENU_ITEM = {
  key: 'seedance-1.5-pro',
  label: 'Seedance 1.5 Pro',
  labelKey: 'seedance15Pro',
  href: '/seedance/1.5-pro',
  logo: '/Logo/bytedance.svg',
  description: 'Flexible text and image generation with native audio.',
};

const SEEDANCE_20_MINI_MENU_ITEM = {
  key: 'seedance-2.0-mini',
  label: 'Seedance 2.0 Mini',
  href: '/seedance/seedance-2-0-mini',
  logo: '/Logo/bytedance.svg',
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Lower-cost drafts with rich reference control.',
};

const SEEDANCE_20_FAST_MENU_ITEM = {
  key: 'seedance-2.0-fast',
  label: 'Seedance 2.0 Fast',
  href: '/seedance/seedance-2-0-fast',
  logo: '/Logo/bytedance.svg',
  description: 'Fast generation across prompts, frames, and references.',
};

const VEO_31_MENU_ITEM = {
  key: 'veo-3.1',
  label: 'Veo 3.1',
  labelKey: 'veo31',
  href: '/veo/veo-3-1',
  logo: '/Logo/google.svg',
  description: 'Cinematic video with native audio and camera control.',
};

const VEO_31_FAST_MENU_ITEM = {
  key: 'veo-3.1-fast',
  label: 'Veo 3.1 Fast',
  labelKey: 'veo31Fast',
  href: '/veo/veo-3-1-fast',
  logo: '/Logo/google.svg',
  description: 'Faster concepts, social clips, and polished drafts.',
};

const VEO_31_LITE_MENU_ITEM = {
  key: 'veo-3.1-fast-lite',
  label: 'Veo 3.1 Lite',
  href: '/veo/veo-3-1-lite',
  logo: '/Logo/google.svg',
  description: 'Lightweight drafts with clean, natural motion.',
};

const GEMINI_OMNI_MENU_ITEM = {
  key: 'gemini-omni',
  label: 'Gemini Omni Flash',
  labelKey: 'geminiOmni',
  href: '/gemini-omni/omni-flash',
  logo: '/Logo/google.svg',
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Fast prompts, visual references, and natural-language edits.',
};

const WAN30_MENU_ITEM = {
  key: 'wan-3.0',
  label: 'Wan 3.0',
  href: '/wan/wan-3-0',
  logo: '/Logo/bailian-color.svg',
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Native audio, rich references, frames, editing, and extension.',
};

const MINIMAX_H3_MENU_ITEM = {
  key: 'minimax-h3',
  label: 'MiniMax H3',
  href: '/minimax/minimax-h3',
  logo: '/Logo/minimax.svg',
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Native multimodal 2K video with frames, references, and editing.',
};
const GROK_IMAGINE_15_MENU_ITEM = {
  key: 'grok-imagine-1.5',
  label: 'Grok Imagine Video 1.5',
  labelKey: 'grokImagine10',
  href: '/grok-imagine/grok-imagine-1-5',
  logo: '/Logo/grok.svg',
  invertLogo: true,
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Image-to-video creation with native audio and flexible framing.',
};

const GROK_IMAGINE_10_MENU_ITEM = {
  key: 'grok-imagine-1.0',
  label: 'Grok Imagine 1.0',
  href: '/grok-imagine/grok-imagine-1-0',
  logo: '/Logo/grok.svg',
  invertLogo: true,
  description: 'Original Grok video model for prompts and references.',
};

const BOTGO_VIDEO_2_MENU_ITEM = newModelMenuItem({
  key: 'botgo-video-2.5',
  label: 'BotGo Video 2.5',
  labelKey: 'botgoVideo25',
  href: '/botgo-video/botgo-video-2-5',
  logo: '/brand/botgo-symbol-white.svg?v=orbit-centered-03',
  description: 'Text, keyframe, and multimodal reference video generation up to 2K.',
});

const KLING_V3_MENU_ITEM = {
  key: 'kling-v3',
  label: 'Kling V3',
  href: '/kling/kling-v3',
  logo: '/Logo/Kling.svg',
  description: 'Cinematic motion with audio and strong direction.',
};

const KLING_V4_MENU_ITEM = newModelMenuItem({
  key: 'kling-v4',
  label: 'Kling 4.0',
  href: '/kling/kling-4-0',
  logo: '/Logo/Kling.svg',
});

const KLING_V3_OMNI_MENU_ITEM = {
  key: 'kling-v3-omni',
  label: 'Kling V3 Omni',
  href: '/kling/kling-v3-omni',
  logo: '/Logo/Kling.svg',
  description: 'Reference-led generation, editing, and extension.',
};

const HAPPY_HORSE_MENU_ITEM = {
  key: 'happyhorse-1.0',
  label: 'HappyHorse 1.0',
  labelKey: 'happyhorse10',
  href: '/happyhorse/happyhorse-1-0',
  logo: '/Logo/happyhorse.png',
  description: 'Human realism, cinematic motion, and expressive close-ups.',
};

const HAPPY_HORSE_11_MENU_ITEM = {
  key: 'happyhorse-1.1',
  label: 'HappyHorse 1.1',
  href: '/happyhorse/happyhorse-1-1',
  logo: '/Logo/happyhorse.png',
  badge: 'New',
  badgeKey: 'new',
  badgeTone: 'new',
  description: 'Stronger reference consistency with native audio direction.',
};

export const AI_VIDEO_FEATURE_MENU = [
  {
    key: 'ai-video-generator',
    label: 'AI Video Generator',
    href: '/ai-video-generator',
    icon: 'sparkles',
    translationKey: 'aiVideoGenerator',
    description: 'Explore every AI video creation workflow.',
  },
  {
    key: 'text-to-video',
    label: 'Text to Video',
    href: '/text-to-video',
    icon: 'type',
    translationKey: 'textToVideo',
    description: 'Turn written prompts into cinematic video.',
  },
  {
    key: 'image-to-video',
    label: 'Image to Video',
    href: '/image-to-video',
    icon: 'image',
    translationKey: 'imageToVideo',
    description: 'Animate images with controlled motion and composition.',
  },
  {
    key: 'reference-to-video',
    label: 'Reference to Video',
    href: '/reference-to-video',
    icon: 'images',
    translationKey: 'referenceToVideo',
    description: 'Keep characters and styles consistent from references.',
  },
  {
    key: 'frames-to-video',
    label: 'Frames to Video',
    href: '/frames-to-video',
    icon: 'frames',
    translationKey: 'framesToVideo',
    description: 'Create motion between start and end frames.',
  },
  {
    key: 'ai-video-editor',
    label: 'AI Video Editor',
    href: '/ai-video-editor',
    icon: 'edit',
    translationKey: 'videoEditor',
    badge: 'New',
    badgeKey: 'new',
    badgeTone: 'new',
    description: 'Edit existing clips with natural-language instructions.',
  },
  {
    key: 'ai-video-extender',
    label: 'AI Video Extender',
    href: '/ai-video-extender',
    icon: 'extend',
    translationKey: 'videoExtender',
    badge: 'New',
    badgeKey: 'new',
    badgeTone: 'new',
    description: 'Continue clips into the next shot or scene.',
  },
];

export const AI_IMAGE_FEATURE_MENU = [
  {
    key: 'ai-image-generator',
    label: 'AI Image Generator',
    href: '/ai-image-generator',
    icon: 'sparkles',
    translationKey: 'aiImageGenerator',
    description: 'Explore every AI image creation workflow.',
  },
  {
    key: 'text-to-image',
    label: 'Text to Image',
    href: '/text-to-image',
    icon: 'type',
    translationKey: 'textToImage',
    description: 'Create polished images from written prompts.',
  },
  {
    key: 'image-to-image',
    label: 'Image to Image',
    href: '/image-to-image',
    icon: 'images',
    translationKey: 'imageToImage',
    description: 'Transform source images while preserving intent.',
  },
  {
    key: 'ai-photo-editor',
    label: 'AI Photo Editor',
    href: '/ai-photo-editor',
    icon: 'brush',
    translationKey: 'aiPhotoEditor',
    badge: 'New',
    badgeKey: 'new',
    badgeTone: 'new',
    description: 'Retouch and transform photos with prompts.',
  },
];

const GPT_IMAGE_2_MENU_ITEM = {
  key: 'gpt-image-2',
  label: 'GPT Image 2',
  labelKey: 'gptImage2',
  href: '/gpt-image/gpt-image-2',
  logo: '/Logo/openai.svg',
  description: 'Precise prompts, clean text, and reference editing.',
};

const NANO_BANANA_MENU_ITEM = {
  key: 'nano-banana',
  label: 'Nano Banana',
  labelKey: 'nanoBanana',
  href: '/nano-banana/nano-banana',
  logo: '/Logo/google.svg',
  description: 'Conversational image creation and fast prompt edits.',
};

const NANO_BANANA_2_LITE_MENU_ITEM = {
  key: 'nano-banana-2-lite',
  label: 'Nano Banana 2 Lite',
  href: '/nano-banana/nano-banana-2-lite',
  logo: '/Logo/google.svg',
  description: 'Fast 1K image generation and editing.',
};

const NANO_BANANA_2_MENU_ITEM = {
  key: 'nano-banana-2',
  label: 'Nano Banana 2',
  labelKey: 'nanoBanana2',
  href: '/nano-banana/nano-banana-2',
  logo: '/Logo/google.svg',
  description: 'Faster generation across flexible aspect ratios.',
};

const NANO_BANANA_21_MENU_ITEM = newModelMenuItem({
  key: 'nano-banana-2.1',
  label: 'Nano Banana 2.1',
  href: '/nano-banana/nano-banana-2-1',
  logo: '/Logo/google.svg',
});

const NANO_BANANA_PRO_MENU_ITEM = {
  key: 'nano-banana-pro',
  label: 'Nano Banana Pro',
  labelKey: 'nanoBananaPro',
  href: '/nano-banana/nano-banana-pro',
  logo: '/Logo/google.svg',
  description: 'High-fidelity visuals for professional creative work.',
};

const SEEDREAM_50_LITE_MENU_ITEM = {
  key: 'seedream-5.0-lite',
  label: 'Seedream 5.0 Lite',
  href: '/seedream/seedream-5-0-lite',
  logo: '/Logo/bytedance.svg',
  description: 'Fast high-resolution generation and image editing.',
};

const SEEDREAM_50_PRO_MENU_ITEM = {
  key: 'seedream-5.0-pro',
  label: 'Seedream 5.0 Pro',
  href: '/seedream/seedream-5-0-pro',
  logo: '/Logo/bytedance.svg',
  description: 'Professional generation with reference-guided editing.',
};

const BOTGO_IMAGE_2_MENU_ITEM = {
  key: 'botgo-image-2',
  label: 'BotGo Image 2',
  href: '/botgo-image/botgo-image-2',
  logo: '/brand/botgo-symbol-white.svg?v=orbit-centered-03',
  badge: 'Unlimited',
  badgeTone: 'unlimited',
  description: 'Fast generation and single-reference editing.',
};

export const HEADER_VIDEO_MODEL_MENU = [
  BOTGO_VIDEO_2_MENU_ITEM,
  BOTGO_VIDEO_25_FLASH_MENU_ITEM,
  SORA_2_MENU_ITEM,
  SORA_2_PRO_MENU_ITEM,
  SEEDANCE_25_MENU_ITEM,
  SEEDANCE_20_MENU_ITEM,
  SEEDANCE_20_FAST_MENU_ITEM,
  SEEDANCE_20_MINI_MENU_ITEM,
  SEEDANCE_15_PRO_MENU_ITEM,
  MINIMAX_H3_MAX_MENU_ITEM,
  MINIMAX_H3_MENU_ITEM,
  WAN30_MENU_ITEM,
  GEMINI_OMNI_11_MENU_ITEM,
  GEMINI_OMNI_MENU_ITEM,
  VEO_31_MENU_ITEM,
  VEO_31_FAST_MENU_ITEM,
  VEO_31_LITE_MENU_ITEM,
  KLING_V4_MENU_ITEM,
  KLING_V3_MENU_ITEM,
  KLING_V3_OMNI_MENU_ITEM,
  GROK_IMAGINE_15_MENU_ITEM,
  GROK_IMAGINE_10_MENU_ITEM,
  HAPPY_HORSE_11_MENU_ITEM,
  HAPPY_HORSE_MENU_ITEM,
];

export const FOOTER_VIDEO_MODEL_MENU = [
  BOTGO_VIDEO_2_MENU_ITEM,
  BOTGO_VIDEO_25_FLASH_MENU_ITEM,
  SORA_2_MENU_ITEM,
  SORA_2_PRO_MENU_ITEM,
  SEEDANCE_25_MENU_ITEM,
  SEEDANCE_20_MENU_ITEM,
  SEEDANCE_15_PRO_MENU_ITEM,
  MINIMAX_H3_MAX_MENU_ITEM,
  MINIMAX_H3_MENU_ITEM,
  WAN30_MENU_ITEM,
  GEMINI_OMNI_11_MENU_ITEM,
  GEMINI_OMNI_MENU_ITEM,
  VEO_31_MENU_ITEM,
  VEO_31_FAST_MENU_ITEM,
  KLING_V4_MENU_ITEM,
  GROK_IMAGINE_15_MENU_ITEM,
  HAPPY_HORSE_MENU_ITEM,
];

export const IMAGE_MODEL_MENU = [
  BOTGO_IMAGE_25_FLASH_MENU_ITEM,
  BOTGO_IMAGE_2_MENU_ITEM,
  GPT_IMAGE_25_MENU_ITEM,
  GPT_IMAGE_2_MENU_ITEM,
  NANO_BANANA_21_MENU_ITEM,
  NANO_BANANA_2_LITE_MENU_ITEM,
  NANO_BANANA_2_MENU_ITEM,
  NANO_BANANA_PRO_MENU_ITEM,
  NANO_BANANA_MENU_ITEM,
  SEEDREAM_50_LITE_MENU_ITEM,
  SEEDREAM_50_PRO_MENU_ITEM,
];

export const MODEL_MENU_BADGE_STYLES = {
  comingSoon: 'border border-amber-500/40 bg-amber-500/15 text-amber-300',
  new: 'border border-amber-500/40 bg-amber-500/15 text-amber-300',
  free: 'border border-amber-500/40 bg-amber-500/15 text-amber-300',
  unlimited: 'border border-emerald-300/65 bg-emerald-500/25 text-emerald-100 shadow-[0_0_10px_rgba(16,185,129,0.18)]',
  hot: 'border border-red-400/60 bg-red-500/25 text-red-100 shadow-[0_0_10px_rgba(239,68,68,0.16)]',
};
